var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-header__main-logo"},[_c('router-link',{attrs:{"tag":"h1","to":{name: 'home'}}},[_c('img',{staticClass:"c-header__main-logo",attrs:{"src":require("@/assets/logos/logo.svg"),"alt":"Meetrika","title":"Meetrika"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }